import { connect } from 'react-redux';
import PlanRenewer from './PlanRenewer';
import { switchMode } from '../../../modules/Subscription';
import { isSubscriptionEnabledSelector } from '../../../reducers/subscriptionSwitch';

const mapStateToProps = state => ({
  switchValue: isSubscriptionEnabledSelector(state),
});

const mapDispatchToProps = {
  switchMode,
};

export default connect(mapStateToProps, mapDispatchToProps)(PlanRenewer);
